export default function compose(...fns) {
  return fns.reduce(
    (accumulation, value) =>
      (...args) =>
        accumulation(value(...args)),
    (x) => x,
  )
}
